import { useState } from "react";

export default function ItemSkill(props) {
  const daley = props.index * 0.6

  const [ItemSkillStyle, SetItemSkillStyle] = useState(animationBlurred(daley));
  const [IconItemSkillStyle, SetIconItemSkillStyle] = useState(animationScale(daley + 0.6));

  function CleanAnimation() {
    SetItemSkillStyle({})
    SetIconItemSkillStyle({})
  }

  return (
    <div className="ItemSkill" style={ItemSkillStyle} onMouseOver={CleanAnimation} onMouseLeave={CleanAnimation}>
      <div className="Header">
        <div className="Icon" style={IconItemSkillStyle}>
          <img className="imgIcon" src={props.icon} alt={`${props.title} icon`} />
        </div>
        <div className="Title">
          {props.title}
        </div>
      </div>
      
      <div className="ItemSkillContents">
        <span className="TextContents">
          {props.description}
        </span>
      </div>
    </div>
  );
}

export function animationBlurred(daley){
  return({
    animation: `slide-in-blurred-bottom  0.3s ${daley}s cubic-bezier(0.230, 1.000, 0.320, 1.000) both`,
  })
}
export function animationScale(daley){
  return({
    animation: `scale-in-center 0.6s ${daley}s cubic-bezier(0.250, 0.460, 0.450, 0.940) both`
  })
}